import useClassy from '@core/hooks/useClassy';
import JumpToContent from '@core/utils/JumpToContent';
import Button from '@ui/Button';

import classes from '../../style.module.scss';

const JumpToButton = () => {
  const bem = useClassy(classes, 'Header');

  return (
    <JumpToContent>
      <Button className={bem('rm-JumpTo', '-jumpTo')} href="#content" target="_self">
        Jump to Content
      </Button>
    </JumpToContent>
  );
};

export default JumpToButton;
